import { VStack } from "@gluestack-ui/themed";
import { SaleValueInfo } from "@repo/core/components/receipt/infos/SaleValueInfo";
import { useDimensions } from "@repo/core/hooks/useDimensions";

export interface LimitDetailsProps {
  limitCredit?: number;
  purchases?: number;
  withdrawals?: number;
  installment?: number;
  monthlyInstallment?: number;
}

export const LimitDetails = ({
  purchases = 0,
  withdrawals = 0,
  installment = 0,
  monthlyInstallment = 0
}: LimitDetailsProps) => {
  const { isMobile } = useDimensions();

  return (
    <VStack
      borderRadius={8}
      borderWidth="$1"
      borderColor="$borderLight200"
      overflow="hidden"
      mb={!isMobile ? "$0" : "$4"}
    >
      <SaleValueInfo name="Compra" value={purchases} isCurrency />
      <SaleValueInfo name="Saque" value={withdrawals} isGray isCurrency />
      <SaleValueInfo name="Parcelamento" value={installment} isCurrency />
      <SaleValueInfo
        name="Parcelamento mês"
        value={monthlyInstallment}
        isGray
        isCurrency
      />
    </VStack>
  );
};
